import type { DatasetInstance } from '../data-builder.store';
import type { DataBuilderDataset } from './api-transform';

export type DatasetLabelMap = Record<string, string>;

export function buildDatasetLabelMap(
  datasets: Pick<DataBuilderDataset, 'id' | 'label'>[] | undefined
): DatasetLabelMap {
  if (datasets === undefined) {
    return {};
  }

  const labelMap: DatasetLabelMap = {};
  for (const dataset of datasets) {
    labelMap[dataset.id] = dataset.label;
  }
  return labelMap;
}

export function buildDatasetInstanceLabelMap(
  instances: DatasetInstance[],
  datasetLabelsByKey: DatasetLabelMap
): Record<string, string> {
  const countByKey: Record<string, number> = {};
  const indexByInstance: Record<string, number> = {};

  for (const instance of instances) {
    const nextIndex = (countByKey[instance.datasetKey] ?? 0) + 1;
    countByKey[instance.datasetKey] = nextIndex;
    indexByInstance[instance.instanceId] = nextIndex;
  }

  return Object.fromEntries(
    instances.map((instance) => {
      const label = (() => {
        if (instance.customLabel !== undefined && instance.customLabel !== '') {
          return instance.customLabel;
        }

        const baseLabel =
          datasetLabelsByKey[instance.datasetKey] ?? instance.datasetKey;
        const count = countByKey[instance.datasetKey] ?? 1;

        if (count === 1) {
          return baseLabel;
        }

        return `${baseLabel} (${indexByInstance[instance.instanceId]})`;
      })();

      return [instance.instanceId, label];
    })
  );
}
